var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_684_1635)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9784 1.93772L18.5393 1.89993L7.20155 13.2376L9.3103 14.5029C9.35253 14.5282 9.38787 14.5636 9.4132 14.6058L10.6785 16.7145L22.0162 5.37682L21.9784 1.93772ZM3.71002 13.0696C3.74125 13.0384 3.78926 13.0314 3.82815 13.0523L8.27959 15.4492C8.33128 15.4771 8.37367 15.5195 8.4015 15.5711L10.7984 20.0226C10.8194 20.0615 10.8123 20.1095 10.7811 20.1407L9.84375 21.078C9.8047 21.1171 9.74139 21.1171 9.70233 21.078L2.77269 14.1484C2.73363 14.1093 2.73363 14.046 2.77269 14.007L3.71002 13.0696ZM6.28893 19.0789L4.55048 17.3404L3.34891 18.542C2.84362 18.5142 2.32906 18.6932 1.94306 19.0792C1.22297 19.7993 1.22297 20.9668 1.94306 21.6869C2.66315 22.407 3.83065 22.407 4.55074 21.6869C4.93704 21.3006 5.11611 20.7855 5.08793 20.2799L6.28893 19.0789Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_684_1635"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSword);
export default __webpack_public_path__ + "static/media/sword.b3d8413ffb0010f4a23622e15ae0175b.svg";
export { ForwardRef as ReactComponent };